module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Выбрать из шаблона":"Select from template","Идет поиск...":"Searching...","Выберите шаблон":"Select template","Для этого типа платежей нет сохраненных шаблонов.":"There are no saved templates for this type of payments.","Для этих платежей нет сохраненных шаблонов.":"There are no saved templates for this type of payments."}}')
  delete Component.options._Ctor
}
